// eslint-disable-next-line @tseslint/typedef, @tseslint/no-unnecessary-type-assertion
export const PROJECT_ROLE_RESOURCE = "project" as const;
// eslint-disable-next-line @tseslint/typedef
export const PROJECT_ROLES = {
  OVERVIEW: "project_overview",
  SETTING_VIEW: "project_setting_view",
  ADMIN: "project_admin",
  RESTRICTED_VIEW: "project_restricted_view",
  EDIT: "project_edit",
  CREATE: "project_create",
  VIEW: "project_view",
  NOTIFICATION_CREATE: "project_notification_create",
  NOTIFICATION_UPDATE: "project_notification_update",
  SETTING_EDIT: "project_setting_edit",
  TAB: "project_tab",
  NOTIFICATION_ADMIN: "project_notification_admin",
  DELETE: "project_delete"
} as const;
export type ProjectRole = typeof PROJECT_ROLES[keyof typeof PROJECT_ROLES];

const allProjectRoles: string[] = Object.values(PROJECT_ROLES) as string[];

export function isProjectRole (role: string): role is ProjectRole {
  return allProjectRoles.includes(role);
}
